import { ValidationErrorMessages } from '@jetslash/market-frontend-shared-core/src/utilities/form/types';
import { ICurrentUser } from '@jetslash/market-frontend-shared-core/src/types/models/user';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { getCurrentUser } from '@jetslash/market-frontend-shared-core/src/api';
import Reporty from '@/utility/errorHandling/Reporty';

interface IProps {
  // currentUser: CurrentUser;
  children: React.ReactNode;
}

interface IDefaultState {
  loading: boolean;
  errors: ValidationErrorMessages;
  signUpUserIsHydrated: boolean;
  signUpStepStartRequest?: () => void;
  signUpStepSuccess?: (newToken?: string | null, loading?: boolean | null) => void;
  signUpStepFailure?: (errors: ValidationErrorMessages) => void;
  setSignUpUser?: (user: ICurrentUser, clearErrors?: boolean) => void;
  signUpUser?: ICurrentUser;
  updateSignUpUser?: () => Promise<ICurrentUser>;
}

const DefaultState: IDefaultState = {
  loading: false,
  errors: null,
  signUpUserIsHydrated: false,
};

export const SignUpWizardContext = React.createContext(DefaultState);

export const SignUpWizardContextProvider: FunctionComponent<IProps> = ({ children }) => {
  const [state, setState] = useState(DefaultState);

  const signUpStepStartRequest = () => {
    setState({
      ...state,
      loading: true,
    });
  };

  const setSignUpUser = (user: ICurrentUser, clearErrors = false) => {
    setState({
      ...state,
      errors: clearErrors ? null : state.errors,
      signUpUser: user,
      signUpUserIsHydrated: true,
    });
  };

  // eslint-disable-next-line consistent-return
  const updateSignUpUser = async (clearErrors = false): Promise<ICurrentUser> => {
    try {
      const payload = await getCurrentUser();
      setSignUpUser(payload.data, clearErrors);
      return payload.data;
    } catch (e) {
      console.error(e);
      setSignUpUser(null);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const signUpStepSuccess = (newToken: string = null, loading = false) => {
    setState({
      ...state,
      loading,
      errors: null,
    });

    updateSignUpUser(true).catch((e) => {
      Reporty.error(e);
    });
  };

  const signUpStepFailure = (errors) => {
    setState({
      ...state,
      loading: false,
      errors,
    });
  };

  useEffect(() => {
    updateSignUpUser()
      .then(() => {})
      .catch((e) => {
        Reporty.error(e);
      });
  }, []);

  return (
    <SignUpWizardContext.Provider
      value={{
        ...state,
        signUpStepStartRequest,
        signUpStepSuccess,
        signUpStepFailure,
        setSignUpUser,
        updateSignUpUser,
      }}
    >
      {children}
    </SignUpWizardContext.Provider>
  );
};
